module.exports = __webpack_public_path__ + "img/logo.89f80b91.jpg";